import { render, staticRenderFns } from "./activityStatistics.vue?vue&type=template&id=05de2dd3&scoped=true"
import script from "./activityStatistics.vue?vue&type=script&lang=js"
export * from "./activityStatistics.vue?vue&type=script&lang=js"
import style0 from "./activityStatistics.vue?vue&type=style&index=0&id=05de2dd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de2dd3",
  null
  
)

export default component.exports